module.exports = __webpack_public_path__ + "img/Courtney.60e5687f.png";